module.exports = __webpack_public_path__ + "img/white.d1a03ea.svg";